export interface StateConfig {
  abbreviation: string;
  name: string;
  defaultZip: string;
  hrHpIncome: number;
}

export const stateConfigs: StateConfig[] = [
  {
    name: "Alabama",
    abbreviation: "AL",
    defaultZip: "36104",
    hrHpIncome: 5573,
  },
  { name: "Alaska", abbreviation: "AK", defaultZip: "99801", hrHpIncome: 8580 },
  {
    name: "Arizona",
    abbreviation: "AZ",
    defaultZip: "85003",
    hrHpIncome: 7306,
  },
  {
    name: "Arkansas",
    abbreviation: "AR",
    defaultZip: "72201",
    hrHpIncome: 6173,
  },
  {
    name: "California",
    abbreviation: "CA",
    defaultZip: "95814",
    hrHpIncome: 9400,
  },
  {
    name: "Colorado",
    abbreviation: "CO",
    defaultZip: "80202",
    hrHpIncome: 9340,
  },
  {
    name: "Connecticut",
    abbreviation: "CT",
    defaultZip: "06103",
    hrHpIncome: 7333,
  },
  {
    name: "Delaware",
    abbreviation: "DE",
    defaultZip: "19901",
    hrHpIncome: 6626,
  },
  {
    name: "Florida",
    abbreviation: "FL",
    defaultZip: "32301",
    hrHpIncome: 6173,
  },
  {
    name: "Georgia",
    abbreviation: "GA",
    defaultZip: "30303",
    hrHpIncome: 7566,
  },
  {
    name: "Hawaii",
    abbreviation: "HI",
    defaultZip: "96810",
    hrHpIncome: 10000,
  },
  { name: "Idaho", abbreviation: "ID", defaultZip: "83702", hrHpIncome: 7293 },
  {
    name: "Illinois",
    abbreviation: "IL",
    defaultZip: "62701",
    hrHpIncome: 7646,
  },
  {
    name: "Indiana",
    abbreviation: "IN",
    defaultZip: "46204",
    hrHpIncome: 6496,
  },
  { name: "Iowa", abbreviation: "IA", defaultZip: "50309", hrHpIncome: 7553 },
  { name: "Kansas", abbreviation: "KS", defaultZip: "66603", hrHpIncome: 6600 },
  {
    name: "Kentucky",
    abbreviation: "KY",
    defaultZip: "40601",
    hrHpIncome: 6160,
  },
  {
    name: "Louisiana",
    abbreviation: "LA",
    defaultZip: "70802",
    hrHpIncome: 6053,
  },
  { name: "Maine", abbreviation: "ME", defaultZip: "04330", hrHpIncome: 5820 },
  {
    name: "Maryland",
    abbreviation: "MD",
    defaultZip: "21401",
    hrHpIncome: 8686,
  },
  {
    name: "Massachusetts",
    abbreviation: "MA",
    defaultZip: "02108",
    hrHpIncome: 10140,
  },
  {
    name: "Michigan",
    abbreviation: "MI",
    defaultZip: "48933",
    hrHpIncome: 6780,
  },
  {
    name: "Minnesota",
    abbreviation: "MN",
    defaultZip: "55101",
    hrHpIncome: 6780,
  },
  {
    name: "Mississippi",
    abbreviation: "MS",
    defaultZip: "39201",
    hrHpIncome: 5700,
  },
  {
    name: "Missouri",
    abbreviation: "MO",
    defaultZip: "65109",
    hrHpIncome: 6386,
  },
  {
    name: "Montana",
    abbreviation: "MT",
    defaultZip: "59601",
    hrHpIncome: 7113,
  },
  {
    name: "Nebraska",
    abbreviation: "NE",
    defaultZip: "68508",
    hrHpIncome: 7180,
  },
  { name: "Nevada", abbreviation: "NV", defaultZip: "89701", hrHpIncome: 6623 },
  {
    name: "New Hampshire",
    abbreviation: "NH",
    defaultZip: "03301",
    hrHpIncome: 8260,
  },
  {
    name: "New Jersey",
    abbreviation: "NJ",
    defaultZip: "08608",
    hrHpIncome: 8460,
  },
  {
    name: "New Mexico",
    abbreviation: "NM",
    defaultZip: "87501",
    hrHpIncome: 6633,
  },
  {
    name: "New York",
    abbreviation: "NY",
    defaultZip: "11208",
    hrHpIncome: 8313,
  },
  {
    name: "North Carolina",
    abbreviation: "NC",
    defaultZip: "27601",
    hrHpIncome: 6173,
  },
  {
    name: "North Dakota",
    abbreviation: "ND",
    defaultZip: "58501",
    hrHpIncome: 8546,
  },
  { name: "Ohio", abbreviation: "OH", defaultZip: "43215", hrHpIncome: 7240 },
  {
    name: "Oklahoma",
    abbreviation: "OK",
    defaultZip: "73102",
    hrHpIncome: 6553,
  },
  { name: "Oregon", abbreviation: "OR", defaultZip: "97301", hrHpIncome: 6173 },
  {
    name: "Pennsylvania",
    abbreviation: "PA",
    defaultZip: "17101",
    hrHpIncome: 7026,
  },
  {
    name: "Rhode Island",
    abbreviation: "RI",
    defaultZip: "02903",
    hrHpIncome: 7673,
  },
  {
    name: "South Carolina",
    abbreviation: "SC",
    defaultZip: "29201",
    hrHpIncome: 6613,
  },
  {
    name: "South Dakota",
    abbreviation: "SD",
    defaultZip: "57501",
    hrHpIncome: 7280,
  },
  {
    name: "Tennessee",
    abbreviation: "TN",
    defaultZip: "37219",
    hrHpIncome: 7480,
  },
  { name: "Texas", abbreviation: "TX", defaultZip: "78701", hrHpIncome: 8920 },
  { name: "Utah", abbreviation: "UT", defaultZip: "84111", hrHpIncome: 9000 },
  {
    name: "Vermont",
    abbreviation: "VT",
    defaultZip: "05602",
    hrHpIncome: 7560,
  },
  {
    name: "Virginia",
    abbreviation: "VA",
    defaultZip: "23219",
    hrHpIncome: 7560,
  },
  {
    name: "Washington",
    abbreviation: "WA",
    defaultZip: "98501",
    hrHpIncome: 8780,
  },
  {
    name: "Washington DC",
    abbreviation: "DC",
    defaultZip: "20002",
    hrHpIncome: 9000,
  },
  {
    name: "West Virginia",
    abbreviation: "WV",
    defaultZip: "25301",
    hrHpIncome: 6410,
  },
  {
    name: "Wisconsin",
    abbreviation: "WI",
    defaultZip: "53703",
    hrHpIncome: 7280,
  },
  {
    name: "Wyoming",
    abbreviation: "WY",
    defaultZip: "82001",
    hrHpIncome: 6406,
  },
];

export const getStateOptions = (
  incomeType?: string,
  program?: string,
  occupancy?: string
) => {
  // States to hide for Non-QM Second Lien
  const secondLienExcludedStates = new Set([
    "HI",
    "IL",
    "MA",
    "NJ",
    "NY",
    "PA",
    "TN",
    "TX",
    "VT",
  ]);

  // Parse program to get the actual program type (before the colon)
  const programParts = program?.split(":") || [];
  const actualProgram = programParts[0];

  // Check if this is Non-QM Second Lien
  const isNonQMSecondLien = actualProgram === "Second Lien";

  // Check if this is DSCR Investment (Income Type starts with "DSCR" and Occupancy is Investment)
  const isDSCRInvestment =
    incomeType?.startsWith("DSCR") && occupancy === "Investment";

  let filteredStates;

  if (isNonQMSecondLien) {
    // For Non-QM Second Lien, hide the specified states
    filteredStates = stateConfigs.filter(
      (state) => !secondLienExcludedStates.has(state.abbreviation)
    );
  } else if (isDSCRInvestment) {
    // For DSCR Investment, show all states including HI and NY
    filteredStates = stateConfigs;
  } else {
    // For all other cases, exclude HI and NY
    filteredStates = stateConfigs.filter(
      (state) => state.abbreviation !== "HI" && state.abbreviation !== "NY"
    );
  }

  return filteredStates.map((state) => ({
    value: state.abbreviation,
    label: state.name,
  }));
};

export const getDefaultZipForState = (stateAbbreviation: string): string => {
  const state = stateConfigs.find((s) => s.abbreviation === stateAbbreviation);
  return state?.defaultZip || "";
};

export const getStateConfigByAbbreviation = (
  stateAbbreviation: string
): StateConfig | undefined => {
  return stateConfigs.find((s) => s.abbreviation === stateAbbreviation);
};
